var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c("div", { staticClass: "mobile-only" }, [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", {
                  staticClass: "mod-icon-arrow-left mod-icon-back",
                  on: {
                    click: function($event) {
                      _vm.$router.back()
                    }
                  }
                }),
                _vm._v(" "),
                _c("h2", { staticClass: "ml-2" }, [_vm._v("Discounts")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grow-1 mr-3" }, [
                _c("div", { staticClass: "input-group search w-100 ml-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keyup: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "desktop-only" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center justify-content-start" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input-group search w-25 ml-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn input-group-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.clearSearch }
                  },
                  [
                    _c("i", {
                      class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                    })
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.q,
                      expression: "q"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search" },
                  domProps: { value: _vm.q },
                  on: {
                    keyup: function($event) {
                      _vm.searchText($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.q = $event.target.value
                    }
                  }
                })
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2 mobile-only mt-3" }, [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between"
            },
            [
              _c("div", {}, [
                _c("p", { staticClass: "text-secondary m-0" }, [
                  _vm._v(
                    "\n            Discounts for " +
                      _vm._s(_vm.meta.total) +
                      " jobs\n          "
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n            $" +
                      _vm._s(_vm.sums.total_amount) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center mb-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-schedule btn-refine",
                    on: {
                      click: function($event) {
                        _vm.showFilters = true
                      }
                    }
                  },
                  [
                    !_vm.clearFiltersButtonShouldBeDisabled
                      ? _c("span", {
                          staticClass: "mobile-dot-refine-active-filters"
                        })
                      : _vm._e(),
                    _vm._v("\n            REFINE\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary expand-all",
                    on: {
                      click: function($event) {
                        _vm.expanded = !_vm.expanded
                      }
                    }
                  },
                  [
                    _c("i", {
                      class: [_vm.expanded ? "fa fa-compress" : "fa fa-expand"]
                    })
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2 desktop-only" }, [
          _c("div", { staticClass: "col-11 filters-field" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filtersLoaded
              ? _c("span", [
                  _vm.filters.move_date
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("move_date")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Move Date: " +
                              _vm._s(_vm.filters.move_date)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.carrier.length && _vm.carriers
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.carrier, function(carrier) {
                          return _c(
                            "span",
                            {
                              key: carrier,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("carrier", carrier)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Carrier: " +
                                  _vm._s(
                                    _vm.carriers.find(function(el) {
                                      return el.id === carrier
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.type.length && _vm.types
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.type, function(type) {
                          return _c(
                            "span",
                            {
                              key: type,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("type", type)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Type: " +
                                  _vm._s(
                                    _vm.types.find(function(el) {
                                      return el.id === type
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.discountUnitTypeId &&
                  _vm.discountUnitTypes &&
                  _vm.discountUnitTypes.length
                    ? _c("span", [
                        _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("discountUnitTypeId")
                                }
                              }
                            }),
                            _vm._v(
                              "\n              Unit: " +
                                _vm._s(
                                  _vm.discountUnitTypes.find(function(el) {
                                    return (
                                      el.id === _vm.filters.discountUnitTypeId
                                    )
                                  }).name
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 d-flex justify-content-end" }, [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary sort-button sort-button-selected",
                  attrs: {
                    id: "dropdownMenuButton",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _vm.selectedKey.length
                    ? _c("i", {
                        staticClass: "fa pr-2",
                        class: [
                          _vm.ascOrDesc === "asc"
                            ? "fa-sort-amount-asc"
                            : "fa-sort-amount-desc"
                        ]
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedKey === "move_date"
                    ? _c("span", [
                        _vm._v("\n              Move date\n            ")
                      ])
                    : _c("span", [
                        _vm._v("\n              Sort by\n            ")
                      ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-caret-down caret" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu sort-dropdown dropdown-menu-right",
                  attrs: { "aria-labelledby": "dropdownMenuButton" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "dropdown-item sort-dropdown-item nav-link btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.sortBy("move_date")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: [
                            _vm.selectedKey === "move_date" ? "selected" : ""
                          ]
                        },
                        [_vm._v("\n                Move date\n              ")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm.selectedKey === "move_date"
                          ? _c("i", {
                              staticClass: "fa",
                              class: [
                                _vm.ascOrDesc === "asc"
                                  ? "fa-sort-amount-asc"
                                  : "fa-sort-amount-desc"
                              ]
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.loading
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : !_vm.discounts.length
          ? [_vm._m(1), _vm._v(" "), _vm._m(2)]
          : [
              _c(
                "div",
                { staticClass: "desktop-only" },
                [
                  _c("DiscountsHeader"),
                  _vm._v(" "),
                  _c("DiscountsStatistics", {
                    staticClass: "blocks",
                    attrs: { meta: _vm.meta, sums: _vm.sums }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "blocks" },
                    _vm._l(_vm.discounts, function(discount, index) {
                      return _c("DiscountsBlock", {
                        key: index,
                        attrs: {
                          discount: discount,
                          "discount-types": _vm.types
                        },
                        on: { update: _vm.filter }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row blocks" },
                    [
                      _vm.meta.total
                        ? _c(
                            "div",
                            { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                            [
                              _vm._v(
                                "\n          Showing " +
                                  _vm._s(_vm.meta.from) +
                                  " - " +
                                  _vm._s(_vm.meta.to) +
                                  " of " +
                                  _vm._s(_vm.meta.total) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("pagination", {
                        staticClass: "col-sm-6 mb-1 pr-0",
                        attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mobile-only" },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._l(_vm.discounts, function(discount) {
                    return _c("DiscountsBlockMobile", {
                      key: discount.id,
                      attrs: {
                        discount: discount,
                        "expanded-all": _vm.expanded
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row blocks" },
                    [
                      _c("pagination", {
                        staticClass: "col-sm-6 mb-1 pr-0",
                        attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters\n            button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Move Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onMoveDateChange
                                        },
                                        model: {
                                          value: _vm.filters.move_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "move_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.move_date"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.move_date
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearMoveDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.types && _vm.types.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Type")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.types,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "type",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.type"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.discountUnitTypes &&
                                _vm.discountUnitTypes.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Unit")]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              "hide-deselect": true,
                                              options: _vm.discountUnitTypes,
                                              label: "name",
                                              placeholder: "Select"
                                            },
                                            on: { input: _vm.search },
                                            model: {
                                              value:
                                                _vm.filters.discountUnitTypeId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "discountUnitTypeId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.discountUnitTypeId"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [_c("h1", [_vm._v("Discounts")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desktop-only" }, [
      _c("span", [_vm._v("There are no results.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mobile-only text-center mb-3" }, [
      _c("span", [_vm._v("There are no results.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-jobs container-fluid m-0 mt-3" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("span", { staticClass: "total-table-title" }, [
            _vm._v("Description")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("span", { staticClass: "total-table-title" }, [_vm._v("Amount")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("span", { staticClass: "total-table-title" }, [_vm._v("Type")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d9a0602", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d9a0602","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Discounts.vue
// module id = null
// module chunks = 